import {useQuery} from "@tanstack/react-query";
import {readPostDetailApi} from "../../../../api/support/board";

interface ReadPostDetailProps {
    id: string;
}

/**
 * 게시글 상세조회 hook
 * @returns
 */
export const useReadPostDetail = (props: ReadPostDetailProps) => {
    const {id} = props;
    const res = useQuery({
        queryKey: ["readPostDetailApi", id],
        queryFn: async (data) => await readPostDetailApi(id),
        // staleTime: 6000 * 10,
        select: (res) => res?.result.postDetailRes,
        retry: false
    });

    return res;
};
